import { Cores, Medias } from 'src/componentes/styles'
import styled from 'styled-components'

export const CorpoModal = styled.div`
  width: 480px;
  background: ${Cores.BRANCO};
  border: 1px solid ${Cores.BRANCO};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 41px 0px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  @media ${Medias.MOBILE} {
    width: 90%;
  }

  @media ${Medias.MOBILE} {
    height: 600px;
  }

  &:first-child {
    margin-top: 20px;

    @media ${Medias.MOBILE} {
      margin-top: 0px;
    }
  }

  h5 {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 30px;
    line-height: 35px;
    text-align: center;
    margin-bottom: 30px;
    margin-top: 10px;

    @media ${Medias.MOBILE} {
      font-size: 20px;
    }
  }

  form {
    width: 100%;
  }
`

export const ContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 80%;

  @media ${Medias.MOBILE} {
    min-width: 90%;
  }

  h5 {
    margin-top: 20px;
  }

  > form > div {
    margin-bottom: 12px;
  }
`

export const ContainerAcoes = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;

  @media ${Medias.MOBILE} {
    flex-direction: column-reverse;
  }

  & > button:not(:first-child) {
    margin-left: 20px;
    @media ${Medias.MOBILE} {
      margin-left: 0px;
      margin-bottom: 20px;
    }
  }

  button {
    @media ${Medias.MOBILE} {
      width: 100%;
    }
  }
`

export const Linha = styled.div`
  display: flex;
  width: 100%;
  gap: 18px;

  @media ${Medias.MOBILE} {
    flex-direction: column;
  }
`

export const ContainerMedio = styled.div`
  width: 50%;
  display: flex;

  @media ${Medias.MOBILE} {
    width: 100%;
    & ~ div {
      margin-left: 0;
    }
  }

  .slcMaior {
    width: 100%;
  }
`
export const ContainerGrande = styled.div`
  width: 100%;
`

export const ContainerOpcoes = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 20px;

  @media ${Medias.MOBILE} {
    flex-direction: column-reverse;
  }

  & > button:last-child {
    margin-left: 20px;
    @media ${Medias.MOBILE} {
      margin-left: 0px;
      margin-bottom: 20px;
    }
  }

  button {
    @media ${Medias.MOBILE} {
      width: 100%;
    }
  }
`
export const Titulo = styled.h5``
export const TextoSemOpcoes = styled.p`
  font-size: 14px;
  text-align: center;
  margin-bottom: 10px;
`
export const ContainerInput = styled.div`
  padding-top: 10px;
  margin-bottom: 0px;
`
